import { render, staticRenderFns } from "./AdminShortcut.vue?vue&type=template&id=ec85a958&scoped=true"
import script from "./AdminShortcut.vue?vue&type=script&lang=js"
export * from "./AdminShortcut.vue?vue&type=script&lang=js"
import style0 from "./AdminShortcut.vue?vue&type=style&index=0&id=ec85a958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec85a958",
  null
  
)

export default component.exports